// extracted by mini-css-extract-plugin
module.exports = {"table_container":"scrolling-table-body_table_container_2NdkF","table":"scrolling-table-body_table_1hsnm","table_column":"scrolling-table-body_table_column_2lWNW"};